import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "../i18n/useTranslation";
import caretIcon from "../assets/caret-down.png";
import styles from "./LanguageSwitcher.module.css";

const AVAILABLE_LANGUAGES: { code: string; label: string }[] = [
    { code: "EN", label: "English" },
    { code: "DE", label: "Deutsch" },
    { code: "FR", label: "Fran�ais" },
    { code: "IT", label: "Italiano" },
];

export function LanguageSwitcher() {
    const { lang, setLang } = useTranslation();
    const normalizedLang = lang?.toUpperCase() ?? "EN";

    const [open, setOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function onClickOutside(event: MouseEvent) {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target as Node)
            ) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", onClickOutside);
        return () => {
            document.removeEventListener("mousedown", onClickOutside);
        };
    }, []);

    const handleSelect = (code: string) => {
        // setLang with lowercase if your i18n expects that,
        // otherwise pass code directly
        setLang(code.toLowerCase());
        setOpen(false);
    };

    return (
        <div className={styles.dropdownContainer} ref={containerRef}>
            <button
                type="button"
                className={styles.dropdownToggle}
                onClick={() => setOpen(prev => !prev)}
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <span className={styles.code}>{normalizedLang}</span>
                <img src={caretIcon} alt="" className={styles.caretIcon} />
            </button>

            {open && (
                <ul className={styles.dropdownList} role="listbox">
                    {AVAILABLE_LANGUAGES.map(entry => (
                        <li
                            key={entry.code}
                            role="option"
                            aria-selected={entry.code === normalizedLang}
                            className={
                                entry.code === normalizedLang
                                    ? `${styles.dropdownItem} ${styles.selected}`
                                    : styles.dropdownItem
                            }
                            onClick={() => handleSelect(entry.code)}
                        >
                            {entry.code}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
